import styled from 'styled-components'

export const ImageContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
`

export const Img = styled.img`
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: ${({useBlur}) => useBlur ? "blur(2px)" : ""};
  opacity: ${({useOpacity, opacityPercent}) => useOpacity ? `${opacityPercent}%` : "100%"};
`

export const NoContentContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NoContentText = styled.span`
  font-size: 1rem;
  font-weight: bold;
`